
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import FileUpload from "@/components/scope/file-upload.vue";
import QRCode from "qrcodejs2";
import AreaSelect from "@/components/scope/area-select.vue";
import { splitThousands, emptyToLine } from "@common/src/utils/common";
import { identityIdRulesEl, checkSocialCreditCodeEl, mobileRulesEl } from "@common/src/utils/verify";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencySymbol } from "@common/src/utils/tools";

import wechatpay from "@/assets/img/wechatpay.png";
import alipay from "@/assets/img/alipay.png";
import bankpay from "@/assets/img/bankpay.png";

const app = namespace("app");
const upgrade = namespace("upgrade");
const user = namespace("user");

@Component({
  components: { FileUpload, AreaSelect }
})
export default class UpgradePay extends Vue {
  @upgrade.Action getFindLatestApply;
  @upgrade.Action queryPurchaseHistory;
  @upgrade.Action informationConfirmedStep;
  @upgrade.Action chooseVersion;
  @upgrade.Action onlinePayment;
  @upgrade.Action findOrder;
  @upgrade.Action offlinePayment;
  @upgrade.Action queryFunctionList;
  @upgrade.Action queryAgentList;
  @app.State btnLoading;

  @user.State selectedOrgCode;
  @user.Action queryStorePayInfo;

  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  dayjs = dayjs;
  t = t;
  cycleType: any = {
    year: t("v210831.year"),
    month: t("v213.special-month")
  };
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  addCurrencySymbol = addCurrencySymbol;
  showSetArriveStoreDate: boolean = false;
  loading = false;
  nextLoading: boolean = false;
  action: number = 0;
  selectAc: number = 2;
  showQRcodePay: boolean = false;
  showOfflinePay: boolean = false;
  versionsFlag: boolean = false;
  photoDefaultList: any = [];
  storePhotoList = [];
  payRecord = [];
  payer = {
    paymentAccountName: "",
    paymentAccount: "",
    paymentCertificate: "",
    id: "defalut"
  };
  payee = {
    name: "",
    bank: "",
    acount: ""
  };
  payerRules = {
    paymentAccountName: [{ required: true, message: t("v260.please-enter-the-payers-account-name"), trigger: "blur" }],
    paymentAccount: [{ required: true, message: t("v260.please-enter-payer-account"), trigger: "blur" }],
    paymentCertificate: [{ required: true, message: t("v210831.please-upload-payment-proof"), trigger: "blur" }],
    id: "defalut"
  };
  upgradeForm: any = {
    age: "",
    storeName: "",
    storePhoto: "",
    id: "defalut",
    legalRepresentativeIdcard: "",
    businessConsultantCode: "",
    k2Name: "",
    licenseId: "",
    imageLink: [],
    region: [],
    address1: "",
    companyPropertyValue: "",
    applyStep: 10,
    districtName: "",
    cityName: "",
    stateName: "",
    applyCode: "",
    appType: "2",
    selectedDiscountPackage: {},
    discountPackageCode: "",
    appTypePriceList: [],
    storeSalesChannelCode: "",
    storeSalesChannelList: [],
    storeSalesChannelContent: {
      agentNo: "",
      operatorName: "",
      operatorPhone: "",
      salesName: "",
      salesPhone: "",
      storeCode: ""
    }
  };
  step3Form: any = {
    name: "",
    region: "",
    type: "",
    payType: "" // 0 线下 1 微信 2支付宝
  };
  upgradeRules = {
    storeName: [{ required: true, message: t("v210831.please-enter-the-store-name"), trigger: "blur" }],
    detailAddress: [{ required: true, message: t("v260.please-enter-the-detailed-address"), trigger: "blur" }],
    legalRepresentative: [{ required: true, message: t("v210831.please-enter-the-legal-person"), trigger: "blur" }],
    legalRepresentativeIdcard: [
      { required: true, message: t("v210831.please-enter-your-id-number"), trigger: "blur" },
      { validator: this.checkRepresentativeId, trigger: "blur" }
    ],
    legalRepresentativePhone: [
      { required: true, message: t("v210831.please-enter-the-legal-person-mobile"), trigger: "blur" }
    ],
    natureBusiness: [{ required: true, message: t("v260.please-select-company-nature"), trigger: "blur" }],
    k2Name: [{ required: true, message: t("v210831.please-enter-the-business-license-name"), trigger: "blur" }],
    licenseId: [
      { required: true, message: t("v210831.please-enter-social"), trigger: "blur" },
      { validator: this.checkLicenseId, trigger: "blur" }
    ],
    address1: [{ required: true, message: t("v260.please-enter-the-detailed-address"), trigger: "blur" }],
    region: [{ required: true, message: t("v260.please-select-your-region"), trigger: "blur" }],
    imageLink: [{ required: true, message: t("v210831.please-upload-store"), trigger: "blur" }],
    companyPropertyValue: [{ required: true, message: t("v260.please-select-company-nature"), trigger: "blur" }],
    "storeSalesChannelContent.salesName": {
      required: true,
      message: t("v213_1.please-enter-the-sales-name-of-jiatong"),
      trigger: "blur"
    },
    "storeSalesChannelContent.salesPhone": [
      {
        required: true,
        validator: (rule, value, callback) => {
          mobileRulesEl(value, callback);
        },
        trigger: "blur"
      }
    ],
    "storeSalesChannelContent.agentNo": {
      required: true,
      message: t("v213_1.please-select-an-agent"),
      trigger: "change"
    },
    "storeSalesChannelContent.operatorName": {
      required: true,
      message: t("v213_1.please-enter-the-operation-name"),
      trigger: "blur"
    },
    "storeSalesChannelContent.operatorPhone": {
      required: true,
      validator: (rule, value, callback) => {
        mobileRulesEl(value, callback);
      },
      trigger: "blur"
    },
    "storeSalesChannelContent.storeCode": {
      required: true,
      message: t("v213_1.please-enter-the-referral-store-code"),
      trigger: "blur"
    }
  };
  checkRepresentativeId(rule, value, callback) {
    identityIdRulesEl(value, callback);
  }
  checkLicenseId(rule, value, callback) {
    checkSocialCreditCodeEl(value, callback);
  }
  handleBannerUploadSuccess() {
    (this.$refs.settingForm as any).validateField("storePhoto");
  }
  created() {
    this.init();
  }

  destroyed() {
    clearInterval(this.paying);
  }
  storeNameDis = false;
  imageLinkDis = false;
  regionDis = false;
  address1Dis = false;
  init() {
    this.getInitData();
    this.queryAgentList({
      pageSize: 999,
      pageNum: 1
    }).then(data => {
      this.agentList = data.data?.list || [];
    });
  }
  getInitData() {
    this.getFindLatestApply().then(res => {
      res.data.optionalPayChannelList.forEach(item => {
        if (item.payChannel === 0) {
          item.src = bankpay;
        } else if (item.payChannel === 1) {
          item.src = wechatpay;
        } else if (item.payChannel === 2) {
          item.src = alipay;
        }
      });
      this.upgradeForm = res.data;
      this.upgradeForm = Object.assign(this.upgradeForm, res.data);

      this.upgradeForm.appType = "2";
      // 处理图片格式
      if (res.data.imageLink) {
        this.upgradeForm.imageLink = res.data.imageLink && res.data.imageLink.split(",");
        this.storePhotoList = res.data.imageLink.map(item => {
          return { url: item };
        });
      } else {
        this.upgradeForm.imageLink = undefined;
      }
      // 设置默认支付方式
      this.step3Form.payType = res.data.optionalPayChannelList && res.data.optionalPayChannelList[0].payChannel;
      this.$nextTick(() => {
        this.upgradeForm.region = [res.data?.stateName, res.data?.cityName, res.data?.districtName];
        this.storeNameDis = Boolean(res.data.storeName);
        this.imageLinkDis = Boolean(this.upgradeForm.imageLink && this.upgradeForm.imageLink.length);
        this.regionDis = Boolean(res.data.stateName);
        this.address1Dis = Boolean(res.data.address1);
      });
    });
  }
  async next() {
    if (this.upgradeForm.applyStep === 10) {
      (this.$refs as any).upgradeForm.validate(async valid => {
        if (valid) {
          this.upgradeForm.stateName = this.upgradeForm.region[0];
          this.upgradeForm.cityName = this.upgradeForm.region[1];
          this.upgradeForm.districtName = this.upgradeForm.region[2];
          try {
            await this.informationConfirmedStep({
              ...this.upgradeForm,
              imageLink: this.upgradeForm.imageLink.toString()
            });
            this.getInitData();
          } catch (e) {
            console.log("[ e ]", e);
          }
        } else {
          return false;
        }
      });
    } else if (this.upgradeForm.applyStep === 20) {
      // 前往支付
      if (!this.upgradeForm.discountPackageCode) {
        return this.$message.error(t("v213.please-select-the-version-to-be-paid-first"));
      }
      this.btnStartLoading();
      await this.chooseVersion({
        discountPackageCode: this.upgradeForm.discountPackageCode,
        applyCode: this.upgradeForm.applyCode
      }).finally(() => {
        this.btnStopLoading();
      });
      this.getInitData();
    }
  }
  pay() {
    if (!this.checkedProtocol) {
      return this.$message.error(t("v213.please-read-and-agree-to-the-agreement-first"));
    }
    let payType = this.step3Form.payType;
    if (!payType) {
      return this.$message.error(t("finance.select-mode-payment"));
    }
    if (payType === 1) {
      this.onlinePaymentFn(payType);
      this.showQRcodePay = true;
    } else if (payType === 2) {
      this.onlinePaymentFn(payType);
      this.showQRcodePay = true;
    } else if (payType === 0) {
      this.showOfflinePay = true;
    }
  }
  async onlinePaymentFn(payChannel) {
    this.loading = true;
    const data = await this.onlinePayment({ applyCode: this.upgradeForm.applyCode, payChannel });
    // 生成支付二维码
    // setTimeout(() => {
    // 传url
    this.qrCode(data.data.paymentInfo);
    this.loading = false;
    this.getFindOrder(data.data.orderNo);
    // }, 200);
  }
  paying: any;
  afterPayInfo = {};
  getFindOrder(orderNo) {
    this.paying = setInterval(async () => {
      const data = await this.findOrder({ orderNo });
      if (data.data.orderStatus === "20") {
        clearInterval(this.paying);
        // 支付成功
        this.afterPayInfo = data.data;
        // 查询最新到期时间和是否优惠续费flag
        this.queryStorePayInfo({ orgCode: this.selectedOrgCode });
        this.showQRcodePay = false;
        this.upgradeForm.applyStep = 60;
        this.$message.success(t("v210831.payment-successful"));
      }
    }, 1000);
  }
  shutDialog() {
    // 删除已存在支付二维码
    document.getElementById("qrcode").innerHTML = "";
    clearInterval(this.paying);
  }
  submitNext(payer) {
    this.nextLoading = true;
    (this.$refs[payer] as any).validate(async valid => {
      if (valid) {
        try {
          const data = await this.offlinePayment({
            ...this.payer,
            paymentCertificate: this.payer.paymentCertificate.toString(),
            applyCode: this.upgradeForm.applyCode
          });
          if (data.code === "0") {
            // this.next();
            this.getInitData();
            this.showOfflinePay = false;
            this.nextLoading = false;
          }
        } catch (error) {
          // console.log("[ error ]", error);
          this.$message.warning(error);
        } finally {
          this.nextLoading = false;
        }
      } else {
        console.log("error submit!!");
        this.nextLoading = false;
        return false;
      }
    });
  }
  copy(text) {
    this.$copyText(text).then(() => this.$message.success(t("v210831.copy-succeeded")));
  }
  qrcode: any = "";
  qrCode(url) {
    document.getElementById("qrcode").innerHTML = "";
    let qrcode = new QRCode("qrcode", {
      width: 144, //图像宽度
      height: 144, //图像高度
      colorDark: "#000000", //前景色
      colorLight: "#ffffff", //背景色
      typeNumber: 4,
      correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
    });
    qrcode.clear(); //清除二维码
    qrcode.makeCode(url); //生成另一个新的二维码
  }
  slectVersions(discountPackageCode) {
    this.upgradeForm.discountPackageCode = discountPackageCode;
  }
  async viewPayRecord() {
    const res = await this.queryPurchaseHistory();
    this.payRecord = res.data;
    this.showSetArriveStoreDate = true;
  }
  appMenuList = {};
  pcMenuList = {};
  appTypeIconList = {};
  async versionsDialog() {
    this.versionsFlag = true;
    const data = await this.queryFunctionList();
    this.appMenuList = data.data.appMenuList;
    this.pcMenuList = data.data.pcMenuList;
    this.appTypeIconList = data.data.appTypeIconList;
  }
  async backStep() {
    this.upgradeForm.applyStep = this.upgradeForm.applyStep - 10;
  }
  checkedProtocol = false;
  get seletedPackageInfo() {
    if (this.upgradeForm && this.upgradeForm.discountPackageCode) {
      return this.upgradeForm.appTypePriceList.find(
        item => item.discountPackageCode === this.upgradeForm.discountPackageCode
      );
    } else {
      return false;
    }
  }
  cycleTypeFormat(typeCode) {
    return this.cycleType[typeCode];
  }
  agentList: any = [];
  handleSalesChannleChange() {
    (this.$refs["upgradeForm"] as any).clearValidate();
  }
}
